import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import PopularLocationManagement from '../../../components/siteadmin/PopularLocation/PopularLocationManagement';
import getPopularLocation from './getPopularLocation.graphql';
import { withQuery } from '../../../hoc/withGraphql';
import Loader from '../../../components/Loader/Loader';

import s from './PopularLocation.css';
function PopularLocation(props) {
    const { data: { getPopularLocation, refetch, loading }, title } = props;

    const [stateVariable, setStateVariable] = useState({
        currentPage: 1,
        searchList: ''
    });

    return (
        loading ? <Loader type={"text"} /> :
            <PopularLocationManagement
                data={getPopularLocation}
                refetch={refetch}
                title={title}
                loading={loading}
                currentPage={stateVariable?.currentPage}
                searchList={stateVariable?.searchList}
                setStateVariable={setStateVariable}
            />
    );
}

PopularLocation.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        loading: PropTypes.bool,
        getPopularLocation: PropTypes.array,
    })
};

export default compose(
    withStyles(s),
    withQuery(getPopularLocation,
        {
            options: {
                fetchPolicy: 'network-only',
                ssr: false
            }
        }),
)(PopularLocation);